export function validateLink(value: string): boolean {
  return /(http(s?)):\/\//i.test(value);
}
export function validateLength(value: string): boolean {
  return !!value.length;
}
